export default __webpack_public_path__ + "static/media/us-flag.95d29a4b.svg";